module.exports = __webpack_public_path__ + "img/blocked_bg.e313c08.svg";